import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-library-item-header',
  imports: [
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    TranslatePipe
  ],
  templateUrl: './library-item-header.component.html',
  styleUrl: './library-item-header.component.scss'
})
export class LibraryItemHeaderComponent {

  @Input() title: string = "Header";
  @Output() closeLibrary = new EventEmitter<void>();
  @Output() unpinLibrary = new EventEmitter<void>();

  constructor() { }

  closeLibraryClick() {
    this.closeLibrary.emit();
  }

  unpinLibraryClick() {
    this.unpinLibrary.emit();
  }

}
